import { render, staticRenderFns } from "./NoArbitrateHome.vue?vue&type=template&id=a42624ac&scoped=true"
import script from "./NoArbitrateHome.vue?vue&type=script&lang=js"
export * from "./NoArbitrateHome.vue?vue&type=script&lang=js"
import style0 from "./NoArbitrateHome.vue?vue&type=style&index=0&id=a42624ac&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a42624ac",
  null
  
)

export default component.exports